import { FULL_ABOUT, GLOBAL_CATALOGS, HAS_DETAILS } from '../types';
import { queryContentList } from './cmsAction';

export const onChangeAboutTabsItem = (value, title) => async (dispatch, getState) => {
  await dispatch({
    type: FULL_ABOUT.Value,
    payload: value
  });
  await dispatch(queryAboutList({ contentCode: value, title }));
};

export const queryAboutList = ({ contentCode, title, ruleTag, page = 1, rowsPerPage = 10 }) => async (dispatch, getState) => {
  await dispatch({
    type: FULL_ABOUT.Loading,
    payload: true
  });
  
  await dispatch({
    type: FULL_ABOUT.List,
    payload: {
      list: [],
      total: 0,
      page: 1,
      rowsPerPage: 10,
      pages: 10,
    }
  });
  
  const response = await dispatch(queryContentList({ contentCode, hasDetails: HAS_DETAILS.True, ruleTag, title, page, rowsPerPage }));
  await dispatch({
    type: FULL_ABOUT.List,
    payload: response
  });

  setTimeout(() => {
    dispatch({
      type: FULL_ABOUT.Loading,
      payload: false
    });
  }, 260);
};

export const queryAboutMenus = (list = []) => (dispatch, getState) => {
  dispatch({
    type: GLOBAL_CATALOGS.About.Root,
    payload: list
  });
};
